import moment from 'moment-timezone'
import "moment/dist/locale/de"
import "moment/dist/locale/fr"
import "moment/dist/locale/es"
import "moment/dist/locale/en-ca"


export const currentLocale = () => {
  const htmlLang = $("html").prop("lang")

  // en-ca includes the same date format as what rails has default for parsing
  if (htmlLang == "en") {
    return "en-ca"
  } else {
    return htmlLang
  }
}

export const initMomentLocale = () => {
  moment.locale(currentLocale())
}

export const currentMomentDateFormat = () => (
  moment()
    .locale(currentLocale())
    .localeData()
    .longDateFormat('L')
)
